var _style, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSocketOutlet01({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Warstwa_1",
    xmlns: "http://www.w3.org/2000/svg",
    x: "0px",
    y: "0px",
    viewBox: "0 0 16 16",
    style: {
      enableBackground: "new 0 0 16 16"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#1E1E1C;}\n\t.st1{fill:#FFFFFF;}\n\t.st2{fill:#FFFFFF;}\n\t.st3{enable-background:new    ;}\n\t.st4{fill:none;stroke:#FFFFFF;stroke-width:0.5;stroke-miterlimit:10;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M3.21,14.35l-0.02-1.49L3.21,1.67l0.26,0.01C6.7,1.81,9.35,4.33,9.63,7.55C9.8,11.07,7.2,14.03,3.7,14.3 L3.21,14.35z M3.71,2.19L3.69,3.68L3.71,13.8c3.2-0.27,5.58-2.99,5.42-6.21C8.88,4.71,6.57,2.43,3.71,2.19z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 9.38,
    y: 7.75,
    className: "st2",
    width: 3.18,
    height: 0.5
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSocketOutlet01);
export default __webpack_public_path__ + "static/media/SocketOutlet-01.f6d5ac599cc47ab7e0a627a1a4d7cb02.svg";
export { ForwardRef as ReactComponent };